import AdditionVisual from "../../components/UKG/Mathematics/AdditionVisual";
import AdditionWordProblem from "../../components/UKG/Mathematics/AdditionWordProblem";
import PictureAddition from "../../components/UKG/Mathematics/PictureAddition";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics - Addition";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/addition/picture-addition", title: "Picture Addition", component: PictureAddition},
    { url: "/ukg/mathematics/addition/visual-addition", title: "Visual Addition", component: AdditionVisual},
    { url: "/ukg/mathematics/addition/word-problem", title: "Word Problem", component: AdditionWordProblem},
];


export default topics;